const React = require('react');
const Prism = require('prismjs');

const Switcher = require('../widgets/Switcher');
const codeHelper = require('../../codeHelper');
const CopyButton = require('../widgets/CopyButton');

const Code = (props) => {
  const { code } = props;

  const lang = 'language-javascript';
  const html = Prism.highlight(code, Prism.languages.javascript, 'javascript');
  return (
    <div className="code">
      <pre className={lang}>
        <code className={lang} dangerouslySetInnerHTML={{ __html: html }} />
      </pre>
      <CopyButton data={code} info="Copy code to clipboard" />
    </div>
  );
};

const Snippet = (props) => {
  const { snippet } = props;

  return (
    <div>
      <div style={{ marginTop: '1em' }}>{snippet.name}
      { snippet.url &&
        <div><a href={snippet.url} target="_blank">🌍 Read more...</a></div>
      }
</div>
      {
        snippet.code &&
          <Code code={snippet.code} />
      }
    </div>
  )
}

const CodePage = (props) => {
  const { node, format, setFormat } = props;

  const generators = {
    js: codeHelper.getJsCode,
    tshell: codeHelper.getTshell,
    cloud: codeHelper.getCloud,
    http: codeHelper.getHttp,
  };

  const generator = generators[format] || generators['js'];
  const snippets = generator(node);
  const codes = snippets.map(s => <Snippet key={s.name} snippet={s} />);
  const formats = [
    { key: 'js', value: 'JavaScript', url: '/doc/TechDocs/Integrations#macros' },
    { key: 'tshell', value: 'Command line', url: '/doc/TechDocs/Integrations#rs-232--ssh-connection' },
    { key: 'cloud', value: 'Webex Cloud', url: '/doc/TechDocs/Integrations#cloud-xapi--workspace-integrations' },
    { key: 'http', value: 'HTTP', url: '/doc/TechDocs/Integrations#https-api' },
  ];

  const name = formats.find(f => f.key === format)?.value || format;
  const url = formats.find(f => f.key === format)?.url || '';
  return (
    <div className="api-code">
      <Switcher values={formats} value={format} onChange={setFormat} />
      {url && <div>🌎 <a href={url} target="_blank">Intro to the {name} API</a></div>}
      {codes}
    </div>
  );
};

module.exports = CodePage;
